/* RapidSneakers cart drawer: animate the second-pair bar and read its message out, add from the second-pair shelf
   (theme B), and open the drawer after /cart sends the shopper back. */
(function () {
  if (!customElements.get('rs-pair-progress')) {
    // The drawer and the cart page swap in fresh HTML after every cart change, so each render is a new element.
    // Remember the last count on window and animate from it. The bar already on the page at load is the starting
    // point, not a change.
    const initial = document.querySelector('rs-pair-progress');
    window.rsPairTier = initial ? Number(initial.dataset.tier) || 0 : 0;
    window.rsPairMessage = initial?.querySelector('[data-rs-pairs-message]')?.textContent.trim() || '';

    // One live region that stays on the page: a region inside the swapped HTML is new each time and is not read out.
    const announce = (message) => {
      let region = document.getElementById('RsPairsLive');
      if (!region) {
        region = document.createElement('div');
        region.id = 'RsPairsLive';
        region.className = 'visually-hidden';
        region.setAttribute('role', 'status');
        region.setAttribute('aria-live', 'polite');
        document.body.appendChild(region);
      }
      region.textContent = '';
      window.setTimeout(() => {
        region.textContent = message;
      }, 100);
    };

    customElements.define(
      'rs-pair-progress',
      class RsPairProgress extends HTMLElement {
        connectedCallback() {
          const message = this.querySelector('[data-rs-pairs-message]')?.textContent.replace(/\s+/g, ' ').trim() || '';
          if (message && message !== window.rsPairMessage) announce(message);
          window.rsPairMessage = message;

          const tier = Number(this.dataset.tier) || 0;
          const previous = window.rsPairTier;
          window.rsPairTier = tier;
          if (previous === tier) return;
          if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

          const segments = this.querySelectorAll('[data-step]');
          segments.forEach((segment) => {
            segment.classList.toggle('is-filled', Number(segment.dataset.step) <= previous);
          });
          void this.offsetWidth;
          segments.forEach((segment) => {
            segment.classList.toggle('is-filled', Number(segment.dataset.step) <= tier);
          });

          if (tier > previous && tier === 2) this.classList.add('is-unlocked');
        }
      }
    );
  }

  // Theme B: the "add a second pair" shelf under the cart lines (snippets/rs-b-shelf.liquid). The add posts to
  // /cart/add with the drawer's sections and hands the response to the drawer, as the product form does, so the
  // drawer redraws (shelf and progress bar included) without a second request.
  if (!customElements.get('rs-shelf')) {
    customElements.define(
      'rs-shelf',
      class RsShelf extends HTMLElement {
        constructor() {
          super();
          // The shelf sits inside <cart-drawer-items>, which reads every change event as a quantity edit.
          this.addEventListener('change', (event) => event.stopPropagation());
          this.addEventListener('submit', this.onSubmit.bind(this));
          this.addEventListener('click', (event) => {
            const arrow = event.target.closest('[data-rs-shelf-step]');
            if (!arrow) return;
            const list = this.querySelector('.rs-shelf__list');
            list.scrollBy({ left: Number(arrow.dataset.rsShelfStep) * list.clientWidth * 0.8, behavior: 'smooth' });
          });
        }

        onSubmit(event) {
          const drawer = document.querySelector('cart-drawer');
          if (!drawer || typeof drawer.renderContents !== 'function') return;
          event.preventDefault();

          const form = event.target;
          const button = form.querySelector('[type="submit"]');
          const error = form.querySelector('.rs-shelf__error');
          if (button.getAttribute('aria-busy') === 'true') return;
          button.setAttribute('aria-busy', 'true');
          error.hidden = true;
          const showError = (message) => {
            error.textContent = message || (window.cartStrings && window.cartStrings.error) || '';
            error.hidden = !error.textContent;
          };

          const body = new FormData(form);
          body.append('sections', drawer.getSectionsToRender().map((section) => section.id));
          body.append('sections_url', window.location.pathname);

          fetch(window.routes.cart_add_url, {
            method: 'POST',
            headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
            body,
          })
            .then((response) => response.json())
            .then((state) => {
              // Shopify's own message for a refused add (sold out meanwhile, quantity limit), in the shop's language.
              if (state.status) return showError(state.description || state.message);
              drawer.renderContents(state);
              // The redraw replaced every element the focus trap knew; trap again on the new ones.
              const container = document.getElementById('CartDrawer');
              if (typeof trapFocus === 'function' && container) {
                trapFocus(container, container.querySelector('.drawer__inner'));
              }
            })
            .catch(() => showError())
            .finally(() => button.removeAttribute('aria-busy'));
        }
      }
    );
  }

  // /cart redirects back to the page the shopper came from with #cart on the URL: open the drawer there.
  if (window.location.hash === '#cart') {
    const drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.open === 'function') {
      history.replaceState(null, '', window.location.pathname + window.location.search);
      drawer.open(document.getElementById('cart-icon-bubble'));
    }
  }
})();
